import { render, staticRenderFns } from "./GetPaysForm.vue?vue&type=template&id=cd5c1c20&"
import script from "./GetPaysForm.vue?vue&type=script&lang=js&"
export * from "./GetPaysForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports